export default function Select({
  value,
  onChange,
  disabled = false,
  children,
  options,
  className = '',
  ...props
}) {
  return (
    <select
      value={value}
      onChange={onChange}
      disabled={disabled}
      className={`w-full px-4 py-2 bg-white dark:bg-background-gray border border-border-light dark:border-border rounded-lg focus:outline-none focus:ring-1 focus:ring-brand-primary focus:border-transparent text-text-primary-light dark:text-text-primary ${
        disabled ? 'opacity-50 cursor-not-allowed' : ''
      } ${className}`}
      {...props}
    >
      {options
        ? options.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))
        : children}
    </select>
  );
}
